import type { InternalAxiosRequestConfig } from "axios";

import { useAuthStore } from "~/stores";

export const authHeaderInterceptor = (config: InternalAxiosRequestConfig) => {
  const accessToken = useAuthStore.getState().accessToken;

  config.headers.Authorization = accessToken
    ? `Bearer ${accessToken}`
    : undefined;

  return config;
};
